module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"fat-happy\"-in-pasadena-california-64b6099b44d20a07f36376b50b242503.png";